import { render, staticRenderFns } from "./TrainingProgram.vue?vue&type=template&id=2c2c94d0&scoped=true"
import script from "./TrainingProgram.vue?vue&type=script&lang=js"
export * from "./TrainingProgram.vue?vue&type=script&lang=js"
import style0 from "./TrainingProgram.vue?vue&type=style&index=0&id=2c2c94d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2c94d0",
  null
  
)

export default component.exports